module.exports = __webpack_public_path__ + "img/IconCapture.a2e0fac7.png";